var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59146 3.52079C8.15396 1.59579 6.47479 0.729126 4.9998 0.729126C4.9998 0.729126 4.9998 0.729126 4.99563 0.729126C3.5248 0.729126 1.84146 1.59163 1.40396 3.51663C0.916462 5.66663 2.23313 7.48746 3.4248 8.63329C3.86646 9.05829 4.43313 9.27079 4.9998 9.27079C5.56646 9.27079 6.13313 9.05829 6.57063 8.63329C7.7623 7.48746 9.07896 5.67079 8.59146 3.52079ZM4.9998 5.60829C4.2748 5.60829 3.6873 5.02079 3.6873 4.29579C3.6873 3.57079 4.2748 2.98329 4.9998 2.98329C5.7248 2.98329 6.31229 3.57079 6.31229 4.29579C6.31229 5.02079 5.7248 5.60829 4.9998 5.60829Z",
    fill: "#E09948"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.242eafc90ed647f3cd0487d9c33774db.svg";
export { ForwardRef as ReactComponent };